import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/pricing/layout.tsx");
